import { render, staticRenderFns } from "./ProductIntegration.vue?vue&type=template&id=4e608edf&scoped=true"
import script from "./ProductIntegration.vue?vue&type=script&lang=js"
export * from "./ProductIntegration.vue?vue&type=script&lang=js"
import style0 from "./ProductIntegration.vue?vue&type=style&index=0&id=4e608edf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e608edf",
  null
  
)

export default component.exports